import { render, staticRenderFns } from "./SafeDropsSummary.vue?vue&type=template&id=6357f340&scoped=true&"
import script from "./SafeDropsSummary.vue?vue&type=script&lang=js&"
export * from "./SafeDropsSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6357f340",
  null
  
)

export default component.exports